import Vue from 'vue'
import { store } from "./shopify/store.js";

// Initialize store
store.init().catch(console.error);

// Components
import Cart from './components/Cart.vue';
const cart = () => new Vue(Cart).$mount('#cart')

import CartStatus from './components/CartStatus.vue';
const cart_status = () => new Vue(CartStatus).$mount('#cartStatus')

import AddToCart from './components/AddToCart.vue';
const add_to_cart = () => new Vue(AddToCart).$mount('add-to-cart')

import Nav from './components/Nav.vue'
const nav = () => new Vue(Nav).$mount('#nav')

import Artworks from './components/Artworks.vue'
const artworks = () => new Vue(Artworks).$mount('#artworksApp')

export { store, cart, cart_status, add_to_cart, nav, artworks }
